import dynamic from 'next/dynamic';

import { BundleLoader } from '../../molecules';

const OtpVerification = dynamic(() => import('./Otp'), { loading: () => <BundleLoader /> });
const PhoneVerification = dynamic(() => import('./Phone'), { loading: () => <BundleLoader /> });

export { OtpVerification, PhoneVerification };
